import React from "react";
import { HeartHandshake, Map, Sprout, Truck } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { assetUrls } from "@/data/products";

const cards = [
  { icon: HeartHandshake, title: "100+ farmers supported", copy: "A direct model designed to strengthen income visibility and farmer dignity." },
  { icon: Map, title: "Hundreds of acres adopted", copy: "A growing hill network cultivated with local farming knowledge." },
  { icon: Sprout, title: "Naturally grown produce", copy: "Seasonal harvests grown without synthetic pesticides or artificial growth inputs." },
  { icon: Truck, title: "Direct farm-to-city model", copy: "Produce moves through a focused route from Tatva Hills to city homes." },
];

export default function FarmersImpact() {
  return (
    <main className="bg-[#FAFAF8] pt-32" data-testid="farmers-impact-page">
      <section className="mx-auto max-w-7xl px-6 pb-24 md:px-10 md:pb-32">
        <SectionHeading eyebrow="Farmers & Impact" title="The harvest is only worth celebrating when the people behind it are respected." copy="Tatva Hills Farm Fresh is built around farmers first — their land, knowledge, work and future income security." testId="impact-page-heading" />
        <div className="overflow-hidden rounded-[2.25rem]">
          <img data-testid="impact-page-image" src={assetUrls.farmers} alt="Tatva Hills farmers carrying a peach harvest" className="aspect-[16/8] w-full object-cover" />
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-4">
          {cards.map((card) => (
            <article data-testid={`impact-page-card-${card.title.toLowerCase().replaceAll("+", "plus").replaceAll(" ", "-")}`} key={card.title} className="rounded-[1.75rem] bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <card.icon className="mb-6 h-6 w-6 text-[#4F795B]" />
              <h3 className="text-xl font-medium text-[#2C2C2A]">{card.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#6B6B66]">{card.copy}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}